const GA_MEASUREMENT_ID = "G-TWHD437QZZ";
export const COOKIE_CONSENT_KEY = "ecotour-cookie-consent";

/**
 * Dados da conversão do Google Ads (clique no botão de WhatsApp).
 * Preencha com os valores do painel do Google Ads:
 *  - ID da conversão: começa com "AW-" (ex.: "AW-1234567890")
 *  - Rótulo da conversão: a parte depois da barra "/" (ex.: "AbCdEfGhIj")
 */
export const GOOGLE_ADS_CONVERSION_ID = "AW-16611118395";
export const GOOGLE_ADS_CONVERSION_LABEL = "5qIlCKL_5b0ZELua5vA9";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let analyticsLoaded = false;

/**
 * Carrega o script do Google Analytics (gtag.js) e configura a medição.
 * Deve ser chamada apenas após o consentimento de cookies do usuário (LGPD).
 */
export function loadGoogleAnalytics(): void {
  if (analyticsLoaded || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  analyticsLoaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { anonymize_ip: true });

  if (isGoogleAdsConfigured()) {
    window.gtag("config", GOOGLE_ADS_CONVERSION_ID);
  }
}

/**
 * Verifica se os dados da conversão do Google Ads já foram configurados.
 */
export function isGoogleAdsConfigured(): boolean {
  return Boolean(GOOGLE_ADS_CONVERSION_ID && GOOGLE_ADS_CONVERSION_LABEL);
}

/**
 * Dispara a conversão do Google Ads referente ao clique no botão de WhatsApp.
 * Só registra após o consentimento de cookies (LGPD).
 */
export function trackWhatsAppConversion(): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  if (!hasAnalyticsConsent() || !isGoogleAdsConfigured()) {
    return;
  }
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`,
  });
}

/**
 * Verifica se o visitante já aceitou os cookies (consentimento salvo).
 */
export function hasAnalyticsConsent(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}